import api, { parseErrorMessage } from "./api";
import { API_ENDPOINTS } from "../config/api.config";

const resolveProfileEndpoint = (username) => {
  if (!username) {
    return API_ENDPOINTS.USER.PROFILE;
  }
  const byUser = API_ENDPOINTS.USER.POSTS_BY_USER
    ? API_ENDPOINTS.USER.POSTS_BY_USER(username)
    : `/users/${username}/`;
  return byUser.endsWith("/") ? byUser : `${byUser}/`;
};

export const getUserProfile = async (username) => {
  const endpoint = resolveProfileEndpoint(username);
  try {
    const response = await api.get(endpoint);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseErrorMessage(error),
      status: error.response?.status,
    };
  }
};

export const updateUserBio = async (bio) => {
  try {
    const response = await api.patch(API_ENDPOINTS.USER.PROFILE, { bio });
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseErrorMessage(error),
    };
  }
};

export const uploadUserAvatar = async (file) => {
  if (!file) {
    return {
      success: false,
      error: "找不到要上傳的頭像檔案",
    };
  }

  const formData = new FormData();
  formData.append("avatar", file);

  try {
    const response = await api.post(API_ENDPOINTS.UPLOAD.AVATAR, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseErrorMessage(error),
      status: error.response?.status,
    };
  }
};

export const getModeratedTopics = async (username) => {
  try {
    const response = await api.get("topics/");
    const topics = Array.isArray(response.data) ? response.data : [];
    return {
      success: true,
      data: topics.filter(
        (topic) => topic?.moderator_info?.username === username
      ),
    };
  } catch (error) {
    return {
      success: false,
      error: parseErrorMessage(error),
      data: [],
    };
  }
};

export default {
  getUserProfile,
  updateUserBio,
  uploadUserAvatar,
  getModeratedTopics,
};
